


























































































































import {
  Component, Vue,
} from 'vue-property-decorator';
import EditCustomGoalInitialAmountViewModel
  from '@/vue-app/view-models/components/goals-dashboard/edit-plan-goals/edit-custom-goal-plan/edit-custom-goal-initial-amount-view-model';

@Component({ name: 'EditCustomGoalInitialAmount' })
export default class EditCustomGoalInitialAmount extends Vue {
  edit_custom_plan_view_model = Vue.observable(
    new EditCustomGoalInitialAmountViewModel(this),
  );

  mounted() {
    this.edit_custom_plan_view_model.initialize();
  }
}
